import { render, staticRenderFns } from "./mouth_gpt_modal.vue?vue&type=template&id=0c24132c"
import script from "./mouth_gpt_modal.vue?vue&type=script&lang=js"
export * from "./mouth_gpt_modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports